import * as instrument from "../../../../assessments/instruments/sample-cans/mini-1-0-r1.js";
import {
  need,
  strength,
} from "../../../../assessments/instruments/sample-cans/responseSets.js";
import type { Decorator } from "../../decorator.js";
import { commentRequiredForAnswers } from "../../decorators/commentRequiredForAnswers.js";
import { formOrder } from "../../decorators/formOrder.js";
import { showGroupWhen } from "../../decorators/showGroupWhen.js";
import { defineRule } from "../../rules.js";
import type { SupportedVersions } from "../../supportedVersions.js";

const { groups, items } = instrument;

/**
 * The order the instrument module lists, which a stored schema does not keep.
 * Rules run in this order, so the item opening the module comes before it.
 */
export const order: Decorator = formOrder(instrument, {
  groups: [
    groups.strengths,
    groups.life_functioning,
    groups.behavioural_emotional_needs,
    groups.developmental_needs,
  ],
  items: [
    items.family_strengths,
    items.interpersonal,
    items.optimism,

    items.family_functioning,
    items.living_situation,
    items.developmental_intellectual,

    items.psychosis,
    items.impulsivity_hyperactivity,
    items.attention_concentration,

    items.cognitive,
    items.developmental,
    items.communication,
  ],
});

/**
 * Any item rated 2 or 3 is explained in a comment, on either scale alike as
 * eCANS asks: on the strength scale a 2 or 3 is a weak strength, not a strong
 * one.
 */
export const commentOnRatingsOfTwoOrMore: readonly Decorator[] = [
  commentRequiredForAnswers(need, [2, 3]),
  commentRequiredForAnswers(strength, [2, 3]),
];

/** The developmental needs module opens once developmental or intellectual needs call for action. */
export const developmentalNeedsWhenRatedForAction: Decorator = showGroupWhen(
  instrument,
  groups.developmental_needs,
  defineRule(
    "developmental/intellectual rated 2 or 3",
    ({ answers }) => (answers.developmental_intellectual ?? 0) >= 2,
  ),
);

export const sampleCansMini_1_0: SupportedVersions = {
  versions: [["sample_cans", "mini", "1.0"]],
  decorators: [
    order,
    ...commentOnRatingsOfTwoOrMore,
    developmentalNeedsWhenRatedForAction,
  ],
};
